import { render, staticRenderFns } from "./TgNavTabs.vue?vue&type=template&id=59ad29bb&"
import script from "./TgNavTabs.vue?vue&type=script&lang=js&"
export * from "./TgNavTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports